/**
 * AGROMX Frontend - Role Service
 * Servicio para gestión de roles del sistema
 */

import api from './api.js';

class RoleService {
  /**
   * Listar todos los roles
   */
  async list() {
    const response = await api.get('/roles');
    return response.data;
  }

  /**
   * Obtener rol por ID (con sus permisos)
   */
  async getById(id) {
    const response = await api.get(`/roles/${id}`);
    return response.data;
  }

  /**
   * Crear rol nuevo
   */
  async create(data) {
    const response = await api.post('/roles', data);
    return response.data;
  }

  /**
   * Actualizar rol
   */
  async update(id, data) {
    const response = await api.put(`/roles/${id}`, data);
    return response.data;
  }

  /**
   * Eliminar rol
   */
  async delete(id) {
    const response = await api.delete(`/roles/${id}`);
    return response.data;
  }

  /**
   * Obtener catálogo de módulos (grupos + módulos + acciones)
   */
  async getCatalogo() {
    const response = await api.get('/modulos');
    return response.data;
  }

  /**
   * Actualizar permisos de un rol
   * @param {number} id
   * @param {Array<{modulo_id:number, accion_id:number}>} permisos
   */
  async updatePermisos(id, permisos) {
    const response = await api.put(`/roles/${id}/permisos`, { permisos });
    return response.data;
  }
}

export default new RoleService();
